// Code generated by Slice Machine. DO NOT EDIT.

import ContactForm from "./ContactForm";
import Image from "./Image";
import Quote from "./Quote";
import Text from "./Text";

export { ContactForm, Image, Quote, Text };

export const components = {
  contact_form: ContactForm,
  image: Image,
  quote: Quote,
  text: Text,
};
